<template>
  <v-dialog v-model="dialog" persistent width="950">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>picture_as_pdf</v-icon> Reporte pdf </v-flex>
        <v-spacer></v-spacer>
        <v-btn flat icon title="Ver en otra ventana" @click="openNewWindow()">
          <v-icon>fullscreen</v-icon>
        </v-btn>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <embed
              :src="url"
              type="application/pdf"
              style="width: 100%; height: 750px"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  // Variables iniciales
  data() {
    return {
      dialog: false,
      loading: false,
      url: ""
    };
  },
  mounted() {
    this.$bus.$on("reporteAsistencia", item => {
      this.url = item;
      console.log(this.url)
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.loading = false;
      this.dialog = false;
	  this.url=""
    },
    openNewWindow() {
      window.open(this.url);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/asistencia/components/PdfView.vue